// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__1m9eR","checkboxCol":"Table_checkboxCol__3E1ur","emailCol":"Table_emailCol__YNlNr","actionCol":"Table_actionCol__-1dUG"};